import { FunctionComponent } from "react";
import { SecaoButao } from "../../../../../components/formulario/styled";
import ModalExportar from "../../../../../components/modalExportar";
import OpenExcelUniversal from "../../../../../components/excel/OpenExcelUniversal";
import SearchInput from "../../../../../components/inputs/searchInput";
import { UseServicesEvent } from "../../context/servicesContext";
import DonwloadPdf from "../../../../../components/pdf/DonwloadPdf";
import ModalCreateEvents from "./modal/create";


interface HeaderComponentProps {

}

const HeaderEventsBatismo: FunctionComponent<HeaderComponentProps> = () => {

  const { listAll, searchPerEvent } = UseServicesEvent();

  return (<>
    <SecaoButao style={{ marginBottom: 5 }}>
      <section style={{ display: 'flex', gap: 5 }}>
        <ModalExportar
          callDownloadExcel={() => OpenExcelUniversal(listAll,
            [
              'id', 'nome_sede', 'descricao', 'nome_cidade',
              'inicio', 'fim', 'ativo', 'inscricao'
            ])}
          callDownloadPdf={() => DonwloadPdf(listAll, [
            "Nome",
            "Idade",
            "Email",
            "Contato",
            "Genero",
            "Estado Civil",
            "Sede",
            "Data Batismo",
            "Inscrição",
            "Camisa",
            "Batizado"
          ],
            [
              'id',
              'nome_sede',
              'descricao',
              'nome_cidade',
              'inicio',
              'fim',
              'ativo',
              'inscricao'
            ],
            listAll?.length, [], `${listAll?.length}`)
          }
        />
      </section>
      <SearchInput
        placeholder="Procure por evento"
        onChange={searchPerEvent}
      />

      <ModalCreateEvents />
    </SecaoButao>
  </>);
}

export default HeaderEventsBatismo;

